import AddressData from './aggregate-register/address.vue';
import Company from './aggregate-register/company.vue';
import Tag from './aggregate-register/tag.vue';
import User from './aggregate-register/user.vue';
// import Vehicle from './aggregate/vehicle.vue';
import vehicles from '../../../../services/vehicles';
import Sales from '../../../../services/sales';
import Contracts from '../../../../services/contracts';
import Vehicles from '../../../../services/vehicles';
import axios from 'axios';
import C from '../../../../pages/common/constantes';
import * as obj from '../../../../pages/common/adhesion/objects';
import { cpfCnpj as cpfCnpjValidator } from '../../../../validators/cpfCnpj';

export default {
  props: ['contractAggregate'],
  data() {
    return {
      loading: undefined,
      step: 0,
      msgError: undefined,
      aggregateType: 'cnpj',
      user: {},
      company: {},
      contact: {},
      address: {},
      vehicles: [],
      vehiclesActive: [],
      plate: '',
      brands: undefined,
      models: undefined,
      brandSelected: {},
      modelSelected: {},
      brandId: undefined,
      modelId: undefined,
      axesId: 1,
      vehiclesSaved: false,
      plates: [],
      // * RNTRC / Sou transportador
      souTransportador: false,
      cpfCnpjTransportador: "",
      anttStatus: null, // 'success' | 'error'
      anttLoading: false,
      mostrarAvisoAntt: false,
      request: {
        contract: {
          "plan": {"planId": 45},
          "changeFlagEmail": "0",
          "lcFlag": 0,
          // contractId: this.contractAggregate.contractId
        },
        contractIdAggregate: this.contractAggregate.contractId,
        moveMaisId: this.contractAggregate.moveMaisId,
        "changeFlagEmail": "0",
        account: {},
        address: {},
        listVehicle: {
          vehicle: []
        },
        value: undefined,
      },
    }
  },
  mounted() {
    this.loading = vehicles.getVehicleBrand()
      .then(data => {
        this.brands = data;
        _.each(data, function (obj) {
          obj.value = obj.brandId;
          obj.caption = obj.name;
        });
        if (!this.brandId){
           this.brandId = data[0].brandId;
           this.loadModels(this.brandId);
        }
      });
  },
  computed: {
    axes(){
      if(!this.modelSelected || !this.modelSelected.categoryId)
        return [{caption: "Selecione o modelo"}];

      if(this.modelSelected.categoryId == 1){
        return _.filter(C.Axes, function(o){
          return o.aut;
        });
      } else if(this.modelSelected.categoryId == 6){
        return _.filter(C.Axes, function(o){
          return o.bus;
        });
      } else if(this.modelSelected.categoryId == 3){
        return _.filter(C.Axes, function(o){
          return o.truck;
        });
      } else {
        return C.Axes;
      }
    },
    plateCompleta() {
      return (this.plate || "").replace(/[^\w]/gi, "").length === 7;
    },
    plateValida() {
      const placa = (this.plate || "").replace(/[^\w]/gi, "").toUpperCase();
      const regexMercosul = /^[A-Z]{3}[0-9][A-J][0-9]{2}$/;
      const regexNormal = /^[A-Z]{3}[0-9]{4}$/;
      return regexMercosul.test(placa) || regexNormal.test(placa);
    },
    transportadorPendente() {
      return this.souTransportador && this.anttStatus !== "success";
    },
    cpfCnpjValido() {
      return cpfCnpjValidator.validate(this.cpfCnpjTransportador || "");
    },
  },
  methods: {
    onPlateInput(event) {
      if (event && event.target) this.plate = event.target.value;
      this.corrigeMascara();
      // Mudar a placa invalida o transportador: desmarca o checkbox,
      // limpa o CPF/CNPJ e apaga a consulta ANTT já realizada.
      if (this.souTransportador || this.cpfCnpjTransportador || this.anttStatus) {
        this.souTransportador = false;
        this.cpfCnpjTransportador = "";
        this.anttStatus = null;
        this.mostrarAvisoAntt = false;
      }
    },
    maskCpfCnpj(value) {
      let d = (value || "").replace(/\D/g, "").slice(0, 14);
      if (d.length <= 11) {
        return d
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      }
      return d
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1/$2")
        .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
    },
    cpfCnpjDigits() {
      return (this.cpfCnpjTransportador || "").replace(/\D/g, "");
    },
    onTransportadorToggle() {
      if (!this.souTransportador) {
        this.cpfCnpjTransportador = "";
        this.anttStatus = null;
      }
      this.mostrarAvisoAntt = false;
    },
    onCpfCnpjInput() {
      this.cpfCnpjTransportador = this.maskCpfCnpj(this.cpfCnpjTransportador);
      this.anttStatus = null;
      this.mostrarAvisoAntt = false;
    },
    consultarAntt() {
      const transportador = this.cpfCnpjDigits();
      const placa = (this.plate || "").replace(/[^\w]/gi, "").toUpperCase();
      if (!transportador || !placa) {
        this.anttStatus = "error";
        return;
      }
      this.anttLoading = true;
      Sales.consultarRNTRC(transportador, [placa])
        .then((resp) => {
          this.anttStatus = this.anttRespostaValida(resp, placa) ? "success" : "error";
          if (this.anttStatus === "success") this.mostrarAvisoAntt = false;
          this.anttLoading = false;
        })
        .catch(() => {
          this.anttStatus = "error";
          this.anttLoading = false;
        });
    },
    // * Sucesso só com RNTRC ativo e a placa na frota ativa (regras ANTT)
    anttRespostaValida(resp, placa) {
      if (!resp || (resp.status && resp.status.code)) return false;
      if (resp.rntrcAtivo !== true) return false;
      if (!Array.isArray(resp.frota)) return false;
      const norm = (p) => (p || "").replace(/[^\w]/gi, "").toUpperCase();
      return resp.frota.some(
        (f) =>
          norm(f.placaVeiculo) === placa &&
          f.situacaoVeiculoFrotaTransportador === true
      );
    },
    reset() {
      this.user = {};
      this.company = {};
      this.vehicles = [];
      this.address = {};
      this.contact = {};
    },
    linkedTag(fn) {
      if (fn)
        this.step += 1;
    },
    addressExists(fn) {
      this.address = fn;
      this.address.validForm = true;
    },
    // VEHICLE METHODS
    loadModels(brandId) {
      if (!brandId) return;
      this.modelId = undefined;
      this.loading = vehicles.getVehicleModel(brandId)
        .then(data => {
          if(false) {
            this.models = _.filter(data, (o) => {return o.categoryId == 1});
          } else{
            this.models = data;
          }
          _.each(this.models, function (obj) {
            obj.value = obj.modelId;
            obj.caption = obj.name;
          });
          if (!this.modelId){
             this.modelId = data[0].modelId;
             this.onModelSelected(data[0]);
            }
        });
    },

    onBrandSelected(item) {
      if(!item)
        return;
      this.brandSelected = item;
      this.brandId = item.brandId;
      this.loadModels(item.brandId);
    },

    onModelSelected(item) {
      this.modelSelected = item;
      this.$nextTick(() => {
        this.axesId = this.axes[0].value;
      });
    },
    corrigeMascara(){
      this.$nextTick(()=>{
        //para o cursor continuar no final do input
        $('#plate').val($('#plate').val());
      });
    },
    async add() {

      await this.$validator.validateAll();
      let vm = this;
      this.errorMessage = undefined;
      vm.errors.clear();
      if (vm.isAdd()) {
        vm.errors.add('plate', 'Já cadastrado');
        return;
      }

      if (this.plate.trim()=='' || this.plate.toString().replace("-", '').length != 7) {
        return;
      }

      if (!this.plateValida) {
        vm.errors.add('plate', 'Placa inválida');
        return;
      }

      // Bloqueio: transportador marcado precisa validar na ANTT com sucesso
      if (this.transportadorPendente) {
        this.mostrarAvisoAntt = true;
        return;
      }
      this.mostrarAvisoAntt = false;

      let promises = []
      promises.push(vehicles.vehicleNotExists(this.plate));

      this.loading = Promise.all(promises).then((success)=>{
        for(var i=0; i<success.length; i++) {
          if(!success[i]){
            vm.$validator.validateAll();
            return Promise.reject('Veículo já cadastrado');
          }
        }

        let v =  obj.vehicle();

        v.plate = vm.plate.toUpperCase();
        v.model.modelId =  vm.modelSelected.modelId;
        v.model.name = vm.modelSelected.name;
        v.model.brand.brandId = vm.brandSelected.brandId;
        v.model.brand.name = vm.brandSelected.name;
        v.categoryAxes.categoryAxesId = vm.axesId;
        v.categoryAxes.name = _.find(vm.axes, function(o){return o.value == vm.axesId}).caption;
        v.tagSerialNumber = undefined;
        v.isTransportador = vm.souTransportador;
        v.cpfCnpjTransportador = vm.souTransportador ? vm.cpfCnpjDigits() : undefined;

        vm.request.listVehicle.vehicle.push(v);
        vm.vehicles.push(v);
        this.plate = '';
        this.souTransportador = false;
        this.cpfCnpjTransportador = '';
        this.anttStatus = null;
        this.vehiclesSaved = true;
      }).catch((error)=>{
        this.errorMessage = error;
        
      });
    },
    isAdd() {
      for (var i = 0; i < this.request.listVehicle.vehicle.length; i++) {
        if (this.request.listVehicle.vehicle[i].plate.toUpperCase().replace("-", "") == this.plate.toUpperCase().replace("-", "")) return true;
      }
      return false;
    },
    remove(index) {
      this.vehicles.splice(index, 1);
      this.request.listVehicle.vehicle.splice(index, 1);
    },
    // AGGREGATE MODAL METHODS
    handleAggregate(val) {
      this.reset();
      this.aggregateType = val;
      if (this.step > 0) {
        this.step = 0;
      }
    },
    nextStep() {
      let vm = this;
      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      switch (this.step) {
        case 0:
          this.loading = this.$refs.accountData.validateAll().then(() => {
            if (this.company.taxIdNumber) {
                this.request.account = {
                  type: "2",
                  taxIdNumber: this.company.taxIdNumber,
                  company: {
                    companyName: this.company.companyName,
                    companyTradeName: this.company.companyTradeName,
                    taxIdNumberFormatted: this.company.taxIdNumberFormatted
                  },
                  accountAuthentication: {
                    "login": this.contact.email,
                    "password": 'MM'+this.company.taxIdNumber,
                    "confirmPassword": 'MM'+this.company.taxIdNumber,
                    "active": "Y"
                  },
                  "nroCellphone": this.contact.nroCellphone,
                  "dddCellphone": this.contact.dddCellphone,

                  "typePhone": "COMERCIAL",
                  "dddPhone": this.contact.dddPhone,
                  "nroPhone": this.contact.nroPhone,
                };
            } else if (this.user.taxIdNumber) {
              this.request.account = {
                "type": "1",
                "taxIdNumber": this.user.taxIdNumber,
                "taxIdNumberFormatted": this.user.taxIdNumberFormatted,
                "person": {
                  "birthDate": this.user.birthDate,
                  "birthDateBR": this.user.birthDateBR,
                  "fullName": this.user.fullName,
                  "name": this.user.name,
                  "lastName": this.user.lastName
                },
                "accountAuthentication": {
                  "login": this.contact.email,
                  "password": 'MM'+this.user.taxIdNumber,
                  "confirmPassword": 'MM'+this.user.taxIdNumber,
                  "active": "Y"
                },
                "nroCellphone": this.contact.nroCellphone,
                "dddCellphone": this.contact.dddCellphone,

                "typePhone": "COMERCIAL",
                "dddPhone": this.contact.dddPhone,
                "nroPhone": this.contact.nroPhone,
              };
            }
            this.step += 1;
          }).catch(err => {
            
            this.msgError = 'Por favor verifique os campos com erro';
          });
          break;
        case 1:
          this.loading = this.$refs.addressData.validateAll().then(_ => {
            vm.request.address = {
              "type": "MAILING",
              "number": this.address.number,
              "complement": this.address.complement,
              "address": this.address.address,
              "neighborhood": this.address.neighborhood,
              "city": this.address.city,
              "state": this.address.state,
              "zipCode": this.address.zipCode
            };
            if (this.address.addressId) {
              vm.request.address.addressId = this.address.addressId;
            }
            this.step += 1;
          }).catch(() => {
            
          });
          break;
        case 2:
          if (this.request.listVehicle.vehicle.length > 0) {
            let filter = {vehicles: this.plates};
            this.doRequestVehiclesForActivate(filter);
          } else {
            this.msgError = 'Adicione ao menos um veículo para continuar';
          }
          break;
        case 3:
          this.step += 1;
          break;
      }
    },
    backStep() {
      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      this.step -= 1;
    },
    doRequestVehiclesForActivate(filter) {
      this.activetagLoading = Vehicles.getVehiclesForActivateByPlate(filter).then((resp) => {
        this.vehiclesActive = resp;
        if (this.vehiclesActive.length > 0) {
          this.step += 1;
        }
      }).catch(error => {
        if (error.data && error.data.status && error.data.status.code==9990)
          return;
      });
    },
    doRequest() {
      let vm = this;

      this.request.value = this.contractAggregate.adhesionTax * this.vehicles.length;
      this.request.contractPaymentMethod = {
        paymentMethod: {paymentMethodId: 109},
        paymentMethodId: 109
      };

      this.loading = Sales.adhesionAggregate(this.request).then(r => {
        this.vehicles.forEach(o => {
          vm.plates.push(o.plate);
        });
        this.vehiclesSaved = false;
        this.nextStep();
      }).catch(err => {
        this.msgError = err.data.status.message;
        this.code = err.data.status.code;
      });

    },
    installTag() {
      this.step += 1;
    },
    closeModal() {
      let close = {
        modal: 'aggregate'
      };
      this.$emit('close', close);
      this.step = 0
    }
  },
  components: {
    AddressData, Company, Tag, User
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/modal-aggregate-register.js